module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
/**SitePage Scene */

(function(fox) { fox.registerWidget('SitePage_Scene', {}, 'Site_Page'); })(fox);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/widget/sitepage/scene.js
// module id = 911
// module chunks = 4